import Vue from 'vue'
import VueRouter from 'vue-router'
import panelMGMTRoutes from './routes';
import accRotes from './accRoutes'
const isAccLoginPage = location.pathname.indexOf('/acc/login') > -1
const isAcc = isAccLoginPage || sessionStorage.getItem('isItem')
const isSysLogin = location.pathname === '/login'
const routes = isSysLogin ? panelMGMTRoutes: (isAcc ? accRotes: panelMGMTRoutes)
if (isAcc) { sessionStorage.setItem('isItem', true) }
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.path.startsWith("/login") || to.path.startsWith("/acc/login")) {
    if (to.path.startsWith("/login") && window.sessionStorage.getItem('isItem')){
      window.sessionStorage.removeItem('isItem')
    }
    window.sessionStorage.removeItem("loginuser");
    next();
  } else {
    //let accessToken = JSON.parse(window.localStorage.getItem('accessToken'))
    let loginuser = window.sessionStorage.getItem("loginuser");
    if (loginuser) {
      next();
    } else {
      next();
    }
  }
});

export default router
